import React, { useState } from "react";
import {
  useStripe,
  useElements,
  PaymentElement,
} from "@stripe/react-stripe-js";
import { Button, Checkbox, FormControlLabel } from "@mui/material";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { setMembership } from "../../../redux/slice/membershipSlice";
import {
  getMembershipByUser,
  getMembershipByUserPS,
} from "../../../services/rest/membership/membershipService";

const CheckoutForm = ({
  setLoading,
  handleOpen,
  hanldeOpenFiled,
  selectedMembership,
  // autoRenew,
  // setAutoRenew,
}) => {
  const { _id, userType } = useSelector((state) => state.userReducer);
  const stripe = useStripe();
  const elements = useElements();
  const dispatch = useDispatch();
  const dateNow = new Date();
  const nextPayment = new Date();
  nextPayment.setMonth(nextPayment.getMonth() + 1);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    if (!stripe || !elements) {
      return;
    }

    try {
      const { error, paymentIntent } = await stripe.confirmPayment({
        elements,
        redirect: "if_required",
      });

      if (error) {
        console.error(error);
        toast.error(
          "Error al procesar el pago. Por favor, inténtalo de nuevo."
        );
      } else if (paymentIntent.status === "succeeded") {
        // console.log("Memebership", selectedMembership);
        // Si el pago fue éxitoso, esperar 10 segundos para verificar el pago en DB
        await new Promise((resolve) => setTimeout(resolve, 20000));
        let currentMembership;
        //Se obtendra todo el historial de pagos en caso de tener membresia activa
        if (userType === "user") {
          currentMembership = await getMembershipByUser({ userId: _id });
        } else {
          currentMembership = await getMembershipByUserPS({ userId: _id });
        }
        // console.log("Nueva membresia BD", currentMembership);
        // console.log("Membresia Pagada:", selectedMembership);

        const lastPayment = dateNow.toISOString();
        const expiredMembership = nextPayment.toISOString();
        console.log("Membresi pagada:", selectedMembership?.planName);
        console.log(
          "Membresia en BD:",
          currentMembership?.activeMemb?.membershipType
        );

        if (
          currentMembership?.activeMemb?.membershipType ===
          selectedMembership?.planName
        ) {
          dispatch(
            setMembership({
              _id: currentMembership?.activeMemb?._id ?? selectedMembership._id,
              planName:
                currentMembership?.activeMemb?.membershipType ??
                selectedMembership.planName,
              price:
                currentMembership?.activeMemb?.amount ??
                selectedMembership.price,
              currency:
                currentMembership?.activeMemb?.currency ??
                selectedMembership.currency,
              description:
                currentMembership?.description ??
                selectedMembership.description,
              routeLimit:
                currentMembership?.routeLimit ?? selectedMembership.routeLimit,
              lastPayment:
                currentMembership?.activeMemb?.paymentDate ?? lastPayment,
              nextPayment:
                currentMembership?.activeMemb?.expiresAt ?? expiredMembership,
              membershipStatus:
                currentMembership?.activeMemb?.status ?? "inactive",
            })
          );
          handleOpen();
          toast.success("Pago exitoso, ahora puedes disfrutar de tu membresía");
        } else {
          hanldeOpenFiled();
        }
      }
    } catch (err) {
      console.error("Error:", err);
      // toast.error("Error al procesar el pago. Por favor, inténtalo de nuevo.");
      hanldeOpenFiled();
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      {/* <FormControlLabel
        control={
          <Checkbox
            checked={autoRenew}
            onChange={(e) => setAutoRenew(e.target.checked)}
            sx={{
              color: "#e7ef7d",
              "&.Mui-checked": {
                color: "#e7ef7d",
              },
            }}
          />
        }
        sx={{ display: "flex", justifyContent: "center" }}
        label="Renovar automáticamente mi membresía"
      /> */}
      <PaymentElement />
      <Button
        variant="contained"
        sx={{ marginTop: 4, backgroundColor: "#e7ef7d" }}
        type="submit"
        disabled={!stripe}
      >
        Pagar
      </Button>
    </form>
  );
};

export default CheckoutForm;
